module.exports = __webpack_public_path__ + "img/img-145.f94bc321.png";